import React from 'react';

interface ArrowDownIconProps {
  isOpen?: boolean;
  width?: number;
  height?: number;
}

const ArrowDownIcon: React.FC<ArrowDownIconProps> = ({
  isOpen = false,
  width = 10,
  height = 5,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        transition: 'transform 0.3s ease',
      }}
    >
      <path d="M5 5L0 0H10L5 5Z" fill="#6E6E6E" />
    </svg>
  );
};

export default ArrowDownIcon;
